import { render, staticRenderFns } from "./CTabsNavigation.vue?vue&type=template&id=746bf662&scoped=true&"
import script from "./CTabsNavigation.vue?vue&type=script&lang=js&"
export * from "./CTabsNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CTabsNavigation.vue?vue&type=style&index=0&id=746bf662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746bf662",
  null
  
)

export default component.exports